/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type PriceGroupsFragment = {
  __typename: "PriceGroups"
  id: string
  values?: Array<string> | null
}

export const PriceGroupsFragmentDoc = gql`
  fragment PriceGroups on PriceGroups {
    id
    values
  }
`
